import { createAsyncThunk } from "@reduxjs/toolkit";
import { isJson } from "Libs/utils";

import { updateOrganizationSubscriptionAlertRequest } from "Api/organizations/subscriptionAlert/updateOrganizationSubscriptionAlert.request";
import logger from "Libs/logger";
import { organizationByDescriptionIdSelector } from "Reducers/organization/organization";
import { selectSubscriptionDetails as organizationSubscriptionSelector } from "Reducers/organization/subscription";

import type {
  OrganizationSubscriptionAlert,
  UpdateOrganizationSubscriptionAlertRequestProps
} from "Api/organizations/subscriptionAlert/types";
import type { AsyncThunkOptionType } from "Reducers/types";

export const updateSubscriptionAlert = createAsyncThunk<
  OrganizationSubscriptionAlert,
  {
    organizationDescriptionId: string;
    subscriptionId: string;
    alertData: UpdateOrganizationSubscriptionAlertRequestProps["alertData"];
  },
  AsyncThunkOptionType
>(
  "app/organization/subscriptionAlert/update",
  async (
    { organizationDescriptionId, subscriptionId, alertData },
    { rejectWithValue, getState }
  ) => {
    try {
      const organization = organizationByDescriptionIdSelector(getState(), {
        organizationDescriptionId
      });

      return await updateOrganizationSubscriptionAlertRequest({
        organizationId: organization!.id,
        subscriptionId,
        alertData
      });
    } catch (_error: any) {
      const error = isJson(_error) ? JSON.parse(_error) : _error;

      const err = error.detail || error.details || error.message;

      logger(err, {
        action: "update_subscription_alert"
      });
      return rejectWithValue(err);
    }
  },
  {
    condition: (
      { organizationDescriptionId, subscriptionId },
      { getState }
    ) => {
      const state = getState();
      const organization = organizationByDescriptionIdSelector(state, {
        organizationDescriptionId
      });
      const subscription = organizationSubscriptionSelector(state, {
        organizationId: organizationDescriptionId,
        subscriptionId
      });

      return !!organization && !!subscription?._links?.update_usage_alerts;
    }
  }
);
